var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FF7D6B",
    strokeWidth: 1.563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 16.668V8.331a1.561 1.561 0 00-.776-1.349l-7.422-4.319a2.34 2.34 0 00-2.355 0L3.9 6.983a1.562 1.562 0 00-.776 1.348v8.337a1.563 1.563 0 00.776 1.35l7.422 4.319a2.343 2.343 0 002.355 0l7.422-4.32a1.563 1.563 0 00.775-1.349zM3.37 7.519l9.13 5.371m0 0l9.13-5.371M12.5 12.89v9.766"
  }))));
}
export default SvgCubeOutline;